import type { MiniTopic } from '@deepguide-ai/types'

/**
 * Get the URL for a topic in a workspace
 */
export function getTopicUrl(
  workspaceSlug: string,
  topic: MiniTopic
): string {
  return `/workspaces/${workspaceSlug}/docs/${topic.canonicalSlug}?docId=${topic.docId}&topicId=${topic.id}`
}

/**
 * Get the base docs URL for a workspace
 */
export function getWorkspaceDocsUrl(
  workspaceSlug: string
): string {
  return `/workspaces/${workspaceSlug}/docs`
}

/**
 * Get the portal URL for a workspace
 */
export function getPortalWorkspaceUrl(
  portalSlug: string,
  workspaceSlug: string
): string {
  return `/portals/${portalSlug}/${workspaceSlug}`
}

/**
 * Get the portal landing URL
 */
export function getPortalUrl(portalSlug: string): string {
  return `/portals/${portalSlug}`
}